import { render, staticRenderFns } from "./gradient.vue?vue&type=template&id=756b4020"
import script from "./gradient.vue?vue&type=script&lang=js"
export * from "./gradient.vue?vue&type=script&lang=js"
import style0 from "./gradient.vue?vue&type=style&index=0&id=756b4020&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports